import { Component, computed, effect, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Spacing, SpacingCase, SpacingCases } from './spacing.model';


@Component({
  selector: 'app-spacing',
  imports: [FormField, MatSelectModule, MatInputModule],
  templateUrl: './spacing.component.html',
  styles: ``,
})
export class SpacingComponent {

  protected readonly spacingCase = SpacingCase;

  readonly form = input.required<FieldTree<Spacing>>();
  readonly label = input.required<string>();

  cases = computed(() => SpacingCases);


  resetCase = effect(() => {
    let validCases = this.cases();
    if (validCases.findIndex(x => x.value === this.form().case().value()) === -1) {
      this.form().case().value.set(validCases[0].value);
    }
  });

  resetEdgeToEdge = effect(() => {
    const spacingCase = this.form().case().value();
    if (this.form().edgeToEdge().dirty() && spacingCase !== SpacingCase.EdgeToEdge) {
      this.form().edgeToEdge().value.set(0.3);
    }
  });

  ngOnDestroy() {
    if (!this.form().edgeToEdge().valid())
      this.form().edgeToEdge().value.set(0);
  }


}
